let gateTooltipTimeout: number;

export const showGateCustomTooltips = (
  tooltipModel,
  thisChart,
  imageList: { [floorName: string]: { [gateName: string]: { entrance: string; exit: string } } }
    | { [pinName: string]: { entrance: string; exit: string } },
  gateList: { [gateName: string]: string },
  channel: 'entrance' | 'exit' | 'auto' = 'entrance',
  showPercentOfTotal = false,
  entranceExitTotal?: { entrance: number; exit: number },
) => {
  window.clearTimeout(gateTooltipTimeout);

  let tooltipEl = document.getElementById('gate-chartjs-tooltip');
  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.id = 'gate-chartjs-tooltip';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.background = 'rgba(0,0,0,0.8)';
    tooltipEl.style.color = 'white';
    tooltipEl.style.borderRadius = '5px';
    tooltipEl.style.padding = '10px';
    document.body.appendChild(tooltipEl);
  }

  if (tooltipModel.opacity === 0) {
    tooltipEl.style.opacity = '0';
    return;
  }

  if (tooltipModel.body && thisChart._data) {
    const chartDatasets = thisChart._data.datasets;
    const titleLines = tooltipModel.title.join(' ');
    const bodyLines = tooltipModel.dataPoints.map((dp, i) => {
      const raw = (typeof dp.yLabel === 'number' ? dp.yLabel : Number(dp.value))
        .toLocaleString();
      const label = chartDatasets[dp.datasetIndex].label;
      if (showPercentOfTotal && entranceExitTotal) {
        const pct = Math.round(((+raw.replace(/,/g, '')) / entranceExitTotal[channel]) * 100);
        return `${label}: ${raw}</br>(${pct}% of total)`;
      }
      return `${label}: ${raw}`;
    });

    let html = '<table style="width:100%;"><thead>';
    html += `<tr><th>${titleLines}</th></tr></thead><tbody>`;
    bodyLines.forEach((line, i) => {
      const { backgroundColor, borderColor } = tooltipModel.labelColors[i];
      html += `
        <tr>
          <td style="font-size:14px">
            <span style="
              display:inline-block;
              width:12px; height:12px;
              background:${backgroundColor};
              border:2px solid ${borderColor};
              vertical-align:middle;
              margin-right:4px;
            "></span>
            ${line}
          </td>
        </tr>`;
    });
    html += '</tbody></table>';
    tooltipEl.innerHTML = html;
  }

  const chartRect = thisChart._chart.canvas.getBoundingClientRect();
  const gateKey = Object.keys(gateList)
    .find(g => gateList[g].replace(/\n/g, ' ') === tooltipModel.title.join(' '))!;
  let floorName = tooltipModel.floorName as string;
  if (floorName === 'ALL') {
    for (const [f, gates] of Object.entries(imageList)) {
      if (gates[gateKey]) { floorName = f; break; }
    }
  }
  const src = imageList?.[floorName]?.[gateKey]?.[channel]
    || imageList?.[gateKey]?.[channel]
    || '../assets/image/placeholder.png';

  const imgW = 200;
  const imgH = 150;

  const imgHtml = `
    <div style="text-align:center;margin-top:8px;">
      <img
        width=${imgW}
        height=${imgH}
        src="${src}"
        style="display:block;margin:0 auto;"
      />
    </div>`;
  tooltipEl.insertAdjacentHTML('beforeend', imgHtml);

  tooltipEl.style.opacity = '1';
  const ttRect = tooltipEl.getBoundingClientRect();
  const ttW = ttRect.width, ttH = ttRect.height;

  const pageX = window.pageXOffset;
  const pageY = window.pageYOffset;
  const chartL = chartRect.left + pageX;
  const chartR = chartRect.right + pageX;
  let leftPos = chartL + tooltipModel.caretX - ttW / 2;
  leftPos = Math.max(leftPos, chartL + 8);
  leftPos = Math.min(leftPos, chartR - ttW - 8);

  const chartT = chartRect.top + pageY;
  const chartB = chartRect.bottom + pageY;
  let topPos = chartT + tooltipModel.caretY - ttH - 10;
  if (topPos < chartT + 8) {
    topPos = chartT + tooltipModel.caretY + 10;
    // if even that overflows bottom, clamp
    if (topPos + ttH > chartB - 8) {
      topPos = chartB - ttH - 8;
    }
  }

  tooltipEl.style.left = `${leftPos}px`;
  tooltipEl.style.top = `${topPos}px`;

  // fade out after 4s
  gateTooltipTimeout = window.setTimeout(() => {
    tooltipEl.style.opacity = '0';
  }, 4000);
};